/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructurePromotionalMaterialsModel } from './restructuring';

class PromotionalMaterialsService {
  async getPromotionalMaterialsList(state, queryParams) {
    const response = await api.get('/promotional-materials', queryParams);
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructurePromotionalMaterialsModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id)
      }
    };
  }
}

export default new PromotionalMaterialsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/promotionalMaterials/services/PromotionalMaterialsService/PromotionalMaterialsService.js